import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaTimes,
  FaTachometerAlt,
  FaUsers,
  FaUserCircle,
  FaShieldAlt,
  FaSignOutAlt,
} from "react-icons/fa";
import { FiHelpCircle } from "react-icons/fi";
import { BiCategory, BiCategoryAlt } from "react-icons/bi";
import { RiPresentationLine } from "react-icons/ri";
import { onErrorLogout } from "../_config/authService";
import { RiBookOpenLine } from "react-icons/ri";
import { MdOutlineSubscriptions } from "react-icons/md";

import logo from "../assets/logo.svg";

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  return (
    <>
      {/* Overlay */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 z-30 lg:hidden"
        />
      )}

      <div
        className={`fixed top-0 left-0 h-full w-64
        bg-[#4096F6] text-white
        dark:bg-[#1E293B]
        flex flex-col transition-all duration-500 z-40 shadow-xl
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* LOGO */}
        <div className="relative py-2 border-b border-white/20 flex justify-center items-center">
          <img src={logo} alt="logo" className="h-12 object-contain" />

          <button
            className="lg:hidden p-2 rounded-md hover:bg-white/10 absolute right-0 top-1/3 -translate-y-1/2"
            onClick={() => setSidebarOpen(false)}
          >
            <FaTimes />
          </button>
        </div>

        {/* MENU */}
        <div className="flex-1 overflow-y-auto custom-scrollbar mt-4">
          <MenuItem
            to="/"
            icon={FaTachometerAlt}
            label="Dashboard"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/users"
            icon={FaUsers}
            label="Users"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/categories"
            icon={BiCategory}
            label="Categories"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/test"
            icon={RiPresentationLine}
            label="Test"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/admin/practice"
            icon={RiBookOpenLine}
            label="Practice"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/category/queze"
            icon={BiCategoryAlt}
            label="Quiz Category"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/quezzes"
            icon={FiHelpCircle}
            label="Quiz Management"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/subscription"
            icon={MdOutlineSubscriptions}
            label="Subscription Management"
            setSidebarOpen={setSidebarOpen}
          />

          <SectionTitle title="System Settings" />

          <MenuItem
            to="/settings/profile"
            icon={FaUserCircle}
            label="Profile Settings"
            setSidebarOpen={setSidebarOpen}
          />

          <MenuItem
            to="/settings/security"
            icon={FaShieldAlt}
            label="Security Settings"
            setSidebarOpen={setSidebarOpen}
          />
        </div>

        {/* LOGOUT */}
        <div className="border-t border-white/20 p-4">
          <button
            onClick={() => setShowLogoutPopup(true)}
            className="flex items-center gap-3 px-4 py-3 w-full rounded-lg
            hover:bg-red-500 transition-colors"
          >
            <FaSignOutAlt className="text-lg" />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>

      {/* LOGOUT POPUP */}
      {showLogoutPopup && (
        <div className="fixed inset-0 bg-black/60 z-[999] flex justify-center items-center">
          <div className="bg-white dark:bg-[#0B1324] p-8 rounded-2xl w-[90%] sm:w-[420px] text-center">
            <h2 className="text-2xl font-semibold mb-4 dark:text-white">
              Logout Confirmation
            </h2>
            <p className="text-sm mb-6 text-gray-600 dark:text-gray-300">
              Are you sure you want to log out?
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={() => setShowLogoutPopup(false)}
                className="bg-gray-200 px-6 py-3 rounded-lg w-32 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => onErrorLogout()}
                className="bg-[#4096F6] text-white px-6 py-3 rounded-lg w-32 hover:bg-[#337ccf]"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* ===== COMPONENTS ===== */

function SectionTitle({ title }) {
  return (
    <p className="text-xs uppercase tracking-wide text-white/70 dark:text-gray-400 px-6 mt-6 mb-2">
      {title}
    </p>
  );
}

function MenuItem({ to, icon: Icon, label, setSidebarOpen }) {
  const base =
    "flex items-center gap-3 px-6 py-3 w-full transition-all duration-200 my-1";

  const inactive =
    "text-white/80 hover:bg-white/10 hover:text-white " +
    "dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-white";

  const active =
    "text-white font-semibold bg-white/20 border-r-4 border-white " +
    "dark:bg-[#4096F6]/20 dark:border-[#4096F6] dark:text-[#4096F6]";

  return (
    <NavLink
      to={to}
      end
      onClick={() => {
        if (window.innerWidth < 1024) setSidebarOpen(false);
      }}
      className={({ isActive }) => `${base} ${isActive ? active : inactive}`}
    >
      <Icon className="text-lg flex-shrink-0" />
      <span className="text-[15px]">{label}</span>
    </NavLink>
  );
}
